import { useQuery } from 'react-query';
import { Route } from 'react-router-dom';

import { api } from 'theSource/utils';
import { GET_DEPENDENTS_QUERY_KEY } from './utils';
import { MyFamilyMemberDetailsPage } from './MyFamilyMemberDetailsPage';
import { MyFamilyMembersViewPage } from './MyFamilyMembersViewPage';
import { MyFamilyMembersAddNewPage } from './MyFamilyMembersAddNewPage';
import { MyFamilyMemberDetailsEditPage } from './MyFamilyMemberDetailsEditPage';
import { Loader, RoutesInternal } from 'theSource/components';
import { DependentsResponseDto } from './types';

export const MyFamily = () => {
  const {
    data: dependentsData,
    isLoading: isLoadingDependents,
    isFetching: isFetchingDependents,
  } = useQuery<DependentsResponseDto>(GET_DEPENDENTS_QUERY_KEY, () =>
    api.get<DependentsResponseDto>('/dependents')
  );

  const isLoading =
    isLoadingDependents || isFetchingDependents || !dependentsData;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <RoutesInternal>
      <Route
        path="/"
        element={<MyFamilyMembersViewPage data={dependentsData!} />}
      />
      <Route
        path="/new"
        element={<MyFamilyMembersAddNewPage data={dependentsData!} />}
      />
      <Route
        path=":dependentId"
        element={<MyFamilyMemberDetailsPage data={dependentsData!} />}
      />
      <Route
        path=":dependentId/edit"
        element={<MyFamilyMemberDetailsEditPage data={dependentsData!} />}
      />
    </RoutesInternal>
  );
};
